module.exports = __webpack_public_path__ + "files/764b31b865670af8b5dc3378fe794db1.png";